import styled from 'styled-components';
import { GoToListPageButton } from '../../../../components/common/buttons/GoToListPageButton';
import { SwiperItemContainer } from '../../../../components/common/itemContainer/SwiperItemContainer';
import { IProduct } from '../../../../interfaces/Product.interfaces';
import { TractorValuePreviewCard } from './TractorValuePreviewCard';
import { IMarketPrice } from '../../../../interfaces/MarketPrice.interfaces';
import { ampli } from '../../../../ampli';

interface TractorValuePreviewCardSwiperProps {
  products: IMarketPrice[];
  type: 'same-brand' | 'similar-engine-output';
}

const SLIDE_WIDTH = 142;

export const TractorValuePreviewCardSwiper = ({ products, type }: TractorValuePreviewCardSwiperProps) => {
  return (
    <Wrapper id={'mpdp-same-brand-swiper-container'}>
      <SwiperItemContainer
        slideItemWidth={SLIDE_WIDTH}
        slideItems={products.map((product) => (
          <TractorValuePreviewCard
            key={product.machine.id}
            product={product as IMarketPrice}
            clickEvent={() => {
              if (type === 'similar-engine-output') {
                ampli.pvmClickSimilarPsModelOnMarketPrice({
                  brand: product.brand.name,
                  model: product.machine.model,
                  hp: product.machine.engineOutputInPs,
                  highest_price: product.maxPrice,
                  lowest_price: product.minPrice,
                });
              }

              if (type === 'same-brand') {
                ampli.pvmClickSameBrandModelOnMarketPrice({
                  brand: product.brand.name,
                  model: product.machine.model,
                  hp: product.machine.engineOutputInPs,
                  highest_price: product.maxPrice,
                  lowest_price: product.minPrice,
                });
              }
            }}
          />
        ))}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
`;
